export const fabricantesInitialState = {
  fabricantes: [],
  fabricante: {},
  fabricanteApagado: {},
  fabricanteAdicionado: {},
  fabricanteEditado: {},
};
